/**
 * The on-screen labels that the VPN instruction strings interpolate: field names, button captions,
 * connection group names and the search term, spelled exactly as Cisco and Midway spell them.
 *
 * Untranslated on purpose. Each one is something the employee has to match against an English Cisco
 * client, so translating it would send them looking for a label their screen does not have.
 *
 * Shared rather than inlined because two surfaces render the same locale keys — the manual step list
 * in {@link ./ConnectVpn.tsx} and the AI overlay's user-turn card — and a value that drifted between
 * them would name the same field two different ways depending on who was driving.
 */
export const VPN_UI_TEXT = {
  ciscoText: "Cisco Secure Client",
  groupText: "Group",
  orcaText: "orca-Amazon-Onboarding",
  orcaCorpText: "Orca-Corp-VPN",
  usernameText: "Username",
  keyPinText: "Security key PIN + Press security key",
  passwordText: "Password",
  spotlightIconText: "Spotlight icon",
  searchTermText: "secure",
  connectText: "Connect",
  signInText: "Sign in",
  pinFieldText: "PIN",
  nextText: "Next",
  okText: "OK",
} as const;

/**
 * The Windows names for the same labels, where they differ. On Windows the Midway PIN goes into the
 * "Windows Security" passkey dialog, which labels its field "Security Key PIN" and submits with
 * "OK" rather than the "Next" the macOS dialog shows. The macOS manual steps keep the shared values
 * above, unchanged.
 */
export const WINDOWS_VPN_UI_TEXT = {
  ...VPN_UI_TEXT,
  pinFieldText: "Security Key PIN",
  nextText: "OK",
} as const;
